import { render } from "./LandingPage.vue?vue&type=template&id=7ac57544&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=7ac57544&lang=css"

import exportComponent from "C:\\Paii\\Projects\\TT Exclusive\\ttex_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__